
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

import { schedule7DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { disagreeReasonListInfoType } from '@/types/Application/ReplyFamilyLawMatter/GuardianShip';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule7 extends Vue {

    @Prop({required:true})
    result!: any;    
    
   
    dataReady = false; 
    guardInfo = {} as schedule7DataInfoType;

    mounted(){
        this.dataReady = false;       
        this.guardInfo = this.getGuardianshipOfChildInfo();       
        this.dataReady = true;
    }    

    public getGuardianshipOfChildInfo(){
        let guardianshipInfo = {} as schedule7DataInfoType;

        guardianshipInfo = {
            opNotGuardian: false,
            opNotGuardianDesc: '',
            opNotSuitable: false,
            opNotSuitableDesc: '',
            other: false,
            otherDesc: ''
        }

        if (this.result.disagreeAppointingGuardianOfChildSurvey?.disagreeReasonList){
            const disagreeReasons: disagreeReasonListInfoType = this.result.disagreeAppointingGuardianOfChildSurvey.disagreeReasonList;           
            guardianshipInfo = {
                opNotGuardian: disagreeReasons.checked.includes('unable'),
                opNotGuardianDesc: (disagreeReasons.checked.includes('unable') && disagreeReasons.unableComment)?disagreeReasons.unableComment:'',
                opNotSuitable: disagreeReasons.checked.includes('unsuitable'),
                opNotSuitableDesc: (disagreeReasons.checked.includes('unsuitable') && disagreeReasons.unsuitableComment)?disagreeReasons.unsuitableComment:'',
                other: disagreeReasons.checked.includes('other'),
                otherDesc: (disagreeReasons.checked.includes('other') && disagreeReasons.otherComment)?disagreeReasons.otherComment:''
            }
        }
        
        return guardianshipInfo;
    }  

}
